import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIllustrationSuccess = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 69,
	viewBox: "0 0 69 69",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_f_42447_16214)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M58.0869 33.7604C58.0869 46.5147 47.7475 56.8542 34.9932 56.8542C22.2388 56.8542 11.8994 46.5147 11.8994 33.7604C11.8994 21.0061 22.2388 10.6667 34.9932 10.6667C47.7475 10.6667 58.0869 21.0061 58.0869 33.7604Z",
				fill: "url(#paint0_linear_42447_16214)"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter1_ii_42447_16214)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M46.012 42.6172C46.012 54.4302 36.4357 64.0065 24.6227 64.0065C12.8097 64.0065 3.2334 54.4302 3.2334 42.6172C3.2334 30.8042 12.8097 21.2278 24.6227 21.2278C36.4357 21.2278 46.012 30.8042 46.012 42.6172Z",
				fill: "#4CDA85",
				fillOpacity: .5
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.1351 36.0271C33.6086 35.4635 34.4502 35.391 35.014 35.8644C35.5778 36.338 35.6516 37.1794 35.178 37.7433L23.6208 51.5011C22.5147 52.8178 20.5102 52.8827 19.3213 51.6404L14.1247 46.2094C13.6158 45.6774 13.6344 44.833 14.1663 44.324C14.6983 43.8151 15.5427 43.8338 16.0517 44.3657L21.2484 49.7967C21.3398 49.8919 21.4941 49.8874 21.5791 49.7863L33.1351 36.0271Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_f_42447_16214",
				x: 1.23275,
				y: 0,
				width: 67.5208,
				height: 67.5208,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						stdDeviation: 5.33333,
						result: "effect1_foregroundBlur_42447_16214"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_ii_42447_16214",
				x: -15.4333,
				y: 2.56118,
				width: 80.1117,
				height: 80.112,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "BackgroundImageFix",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: -5.33333 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect1_innerShadow_42447_16214"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {
						dx: 2.66667,
						dy: 5.33333
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.33333 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_innerShadow_42447_16214",
						result: "effect2_innerShadow_42447_16214"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_42447_16214",
				x1: 24.6682,
				y1: 23.9212,
				x2: 76.426,
				y2: 50.4494,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#008500" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4CDA85"
				})]
			})
		] })
	]
});
export default SvgIllustrationSuccess;
